import Navbar from './components/Navbar'
import HeroSection from './components/HeroSection'
import AboutSection from './components/AboutSection'
import ValuesSection from './components/ValuesSection'
import ActivitiesSection from './components/ActivitiesSection'
import VisionSection from './components/VisionSection'
import GallerySection from './components/GallerySection'
import NoticeSection from './components/NoticeSection'
import Footer from './components/Footer'

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ValuesSection />
        <ActivitiesSection />
        <VisionSection />
        <GallerySection />
        <NoticeSection />
      </main>
      <Footer />
    </div>
  )
}